export default __webpack_public_path__ + "static/media/RW.c6c247cf.svg";